<div *ngIf="isVisible" >
    <div>
        <h3 class="tooltip-text">{{Mensaje}}</h3>
    </div>
</div>